module.exports = __webpack_public_path__ + "static/media/star-icon.e536e978.svg";